import { render, staticRenderFns } from "./checkboxs.vue?vue&type=template&id=4af57754&scoped=true&"
import script from "./checkboxs.vue?vue&type=script&lang=js&"
export * from "./checkboxs.vue?vue&type=script&lang=js&"
import style0 from "./checkboxs.vue?vue&type=style&index=0&id=4af57754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af57754",
  null
  
)

export default component.exports